import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ContainerImageModel,
  ContainerModel,
} from '@app/models/server/layout.model';
import { NgOptimizedImage, SlicePipe } from '@angular/common';
import { NEW_IMAGE_PLACEHOLDERS } from '@app/constants/app-settings';
import { ModalController } from '@ionic/angular/standalone';

@Component({
  selector: 'app-b2b-image-gallery',
  templateUrl: './b2b-image-gallery.component.html',
  styleUrls: ['./b2b-image-gallery.component.scss'],
  standalone: true,
  imports: [SlicePipe, NgOptimizedImage],
})
export class B2bImageGalleryComponent implements OnInit {
  @Input() compData: {
    container: ContainerModel;
    width?: number;
    height?: number;
  };
  /*@Input({
    required: true,
  }) imageQualityHeight: string;*/
  @Input() showAllImages: boolean;
  @Input() diffImageSizes: { width: number; height: number }[] = [];

  placeHolderImage: string;

  start: number = Number(0);
  end: number;

  finalImages?: ContainerImageModel[];
  rawImages?: ContainerImageModel[];

  @Output() imageClicked: EventEmitter<{
    image: ContainerImageModel;
  }> = new EventEmitter<{
    image: ContainerImageModel;
  }>();

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.placeHolderImage = this.compData?.container?.placeHolderImagePath;
    if (!this.placeHolderImage) {
      this.placeHolderImage = NEW_IMAGE_PLACEHOLDERS?.hotel;
    }
    if (this.compData?.container?.allImages?.length > 0) {
      this.rawImages = this.compData?.container?.allImages;
    } else if (this.compData?.container?.promotionImages?.length > 0) {
      this.rawImages = this.compData?.container?.promotionImages;
    }

    if (this.compData?.container?.imageSliceLength > 0) {
      this.end = this.compData?.container?.imageSliceLength;
    } else {
      this.end = this.rawImages?.length;
    }

    if (this.showAllImages) {
      this.finalImages = this.rawImages;
    } else {
      if (this.rawImages?.length < this.end) {
        const diff = this.end - this.rawImages?.length;
        for (const i of new Array(diff)) {
          this.rawImages?.push({
            path: NEW_IMAGE_PLACEHOLDERS?.hotel,
            alt: 'TODO image',
          });
        }
        this.finalImages = this.rawImages;
      } else {
        this.finalImages = this.rawImages;
      }
    }
  }

  async openImageGallery() {
    const module = await import(
      '@app/new-ui-lib/b2b-gallery/components/b2b-image-gallery-modal/b2b-image-gallery-modal.component'
    );

    const componentProps: {
      title: string;
      container?: ContainerModel;
      showAllImages?: boolean;
      width: number;
      height: number;
    } = {
      title: 'All Images',
      container: this.compData?.container,
      showAllImages: true,
      width: this.compData?.width,
      height: this.compData?.height,
    };

    const modal: HTMLIonModalElement = await this.modalController.create({
      component: module?.B2bImageGalleryModalComponent,
      componentProps,
      cssClass: 'image-gallery-modal',
      initialBreakpoint: 1,
      breakpoints: [0, 1],
    });

    modal.onDidDismiss().then((result) => {
      if (result && result.data) {
      }
    });

    return await modal.present();
  }

  onImageClick(image: ContainerImageModel) {
    this.imageClicked.emit({ image });
  }

  onLimitedImageClick() {
    this.openImageGallery().then();
  }
}
